import TextInput from "/src/components/UI/TextField/TextInput";
import { useTreeStateContext } from "../../../contexts/TreeContext";
import { useState, useRef } from "react";
import useBlockJump from "../../../hook/block/useBlockCamera";
import useCategoryJump from "../../../hook/category/useCategoryCamera"
import "./SearchBar.css";

// Component for listing all the block's in the bot editor thanks to their name
function SearchBar() {

    const { blocks, categories } = useTreeStateContext();
    const { followBlock } = useBlockJump();
    const {followCategory} = useCategoryJump()
    const [list, setList] = useState([]);
    var [value, setValue] = useState('');

    const onChange = (e) => {
        value = e.target.value.toLowerCase();
        setValue(value);
        setList(filter(value));
    }

    const onBlur = (e) => {
        // Timeout on the change state for the animation (conflict with onChange)
        setTimeout( () => setValue(""), 200)
    }
    /**
     * Filter all the editor's blocks by ther name or content if they are 'propos' types
     * @returns blocks 
     */
    const filter = (val) => {
        let res = [];
        res.categories =  categories.filter( ({ category }) => category.name.toLowerCase().includes(val))
        res.blocks = blocks.filter(({ name, object_id, data }) =>
        name.toLowerCase().includes(val) ||
        (data.messages && data.messages.find(({ content }) => content.toLowerCase().includes(val))) ||
        object_id.includes(val));
        return res;
    }

    const style = {
        hidden :  {opacity: 0, pointerEvents: "none"},
        visible : {opacity: 1, pointerEvents: "auto"}
    }

    // If no blocks find don't shows the list

    return(
        <>
            <TextInput  className={(value ? 'glue' : '')} onChange={onChange} onBlur={onBlur} value={value}></TextInput>
            <ul style={value && list ? style.visible : style.hidden} id="search_bar_ul" className="scrollbar white">
                {value && list && list.blocks.map(block => {
                    return <li key={block.object_id} className={"search_bar_li " + block.type.name} onClick={() => followBlock(block.object_id)}>{block.name}</li>
                })}
                {value && list && list.categories.map(infoCategory => {
                    return <li key={infoCategory.object_id} className={"search_bar_li"}  style={{color: infoCategory.category.color,paddingLeft : "15px"}} onClick={() => followCategory(infoCategory.object_id)}><i className="fas fa-cube" style={{width: "5px"}}></i> <span style={{ marginLeft : "18px"}}>{infoCategory.category.name}</span></li>
                })}
            </ul>
        </>
    )
}

export default SearchBar;